// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hE-z","hovered":"iE-z","hoverImage":"jE-z","mainImage":"kE-z","imageNoBackground":"lE-z","fullSizeImage":"mE-z"};